module.exports = __webpack_public_path__ + "static/media/recenter.405d0b38.svg";